export default __webpack_public_path__ + "static/media/cp_uo_unknown.dd60f2b7.svg";